import { toaster } from "../components/toaster";
import { DefaultService } from "../generated";
import { useMutation } from "@tanstack/react-query";

export const useSignupNewsletter = () => {
  return useMutation({
    mutationKey: ["signupNewsletter"],
    mutationFn: (data: { email: string }) =>
      DefaultService.fakturNewsletterViewsSignUpForNewsletter({
        email: data.email,
      }),
    onSuccess: () => {
      toaster.success({ title: "E-post er meldt på!" });
    },
  });
};
